export const desktopNavBgColor = "rgba(1, 33, 74, 0.98)"
